import { createEntityAdapter } from '@reduxjs/toolkit';
import { GameListItemDTO, GameRewardsDTO } from '../types';

export const gamesAdapter = createEntityAdapter<GameListItemDTO>({
  selectId: game => game.id,
});

export const gameRewardsAdapter = createEntityAdapter<GameRewardsDTO>({
  selectId: gameReward => gameReward.localId,
});
